module.exports = __webpack_public_path__ + "img/American-Credit-logo-TM-960w.51ad5fa.png";